import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
} from "shards-react";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";

const axios = require("axios").default;

const StyledModalFooter = styled(ModalFooter)`
  justify-content: center;
`;

const ModalDeleteBanner = (props) => {
  const { token } = useToken();
  const { open, toggle, data ,openEdit} = props;
  const [filePath, setFilePath] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [bannerSettingLink, setBannerSettingLink] = useState(null);
  const [bannerSettingId, setBannerSettingId] = useState(null);

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };

  const splitPath = (path) => {
    if (path.includes("\\")) {
      var s = path.split("\\");
      return s[1];
    } else {
      return path;
    }
  };
  const deleteBanner = () => {
    const sendObject = {
      bannerSettingId: bannerSettingId,
      bannerSettingPic: filePath,
    };
    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/deletebanner`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: sendObject,
    };

    axios(config)
      .then((response) => {
        showNotify("แจ้งเตือน! ลบข้อมูลเรียบร้อย");
        toggle();
      })
      .catch((error) => {
        console.log(error);
        if(error.response.data.message){
          showNotify(error.response.data.message, "error");
        }else{
          showNotify(error.message, "error");
        }
      });
  };
  useEffect(() => {
    if (data) {
      setFilePath(data.bannerSettingPic);
      setFileName(splitPath(data.bannerSettingPic));
      setBannerSettingId(data.bannerSettingId);
      setBannerSettingLink(data.bannerSettingLink);
    } else {
      setFilePath(null);
      setFileName(null);
      setBannerSettingId(null);
      setBannerSettingLink(null);
    }
  }, [data]);
  return (
    <>
      <ToastContainer />
      <Modal size="md" open={open} toggle={toggle}>
        <ModalBody>ยืนยันการลบรูปภาพ Banner ใช่หรือไม่?</ModalBody>
        <StyledModalFooter>
          <Button
            className="btn-white"
            style={{ width: "150px" }}
            onClick={() => {
                toggle();
                openEdit();
            }}
          >
            ยกเลิก
          </Button>
          <Button
            className="btn-danger pull-right"
            style={{ width: "150px" }}
            onClick={deleteBanner}
          >
            ลบ
          </Button>
        </StyledModalFooter>
      </Modal>
    </>
  );
};

export default ModalDeleteBanner;
